import {z} from 'zod';
import {UpdateEvaluationRequest} from '../../api/generated/index.defs';
import {mapNullToUndefined, mapStringToBoolean} from '../../utils/zod';

export const evaluationSchema = z.object({
  isRepairable: mapNullToUndefined(mapStringToBoolean(z.boolean().optional())),
  nonRepairableReason: mapNullToUndefined(z.string().optional()),
  nonRepairableRemarks: mapNullToUndefined(z.string().optional()),
  isCompleted: mapStringToBoolean(z.boolean().optional()),
  isQuoted: mapStringToBoolean(z.boolean().optional()),
  isQuoteApproved: mapNullToUndefined(
    mapStringToBoolean(z.boolean().optional())
  ),
  quoteDisapprovalReason: mapNullToUndefined(z.string().optional()),
  quoteReference: mapNullToUndefined(z.string().optional()),
  quoteRemarks: mapNullToUndefined(z.string().optional()),
  workPerformedSummary: mapNullToUndefined(z.string().optional()),
}) satisfies z.Schema<UpdateEvaluationRequest>;
export type EvaluationSchema = z.TypeOf<typeof evaluationSchema>;
